import { render, staticRenderFns } from "./SGM.vue?vue&type=template&id=9c367f42&scoped=true&"
import script from "./SGM.vue?vue&type=script&lang=js&"
export * from "./SGM.vue?vue&type=script&lang=js&"
import style0 from "./SGM.vue?vue&type=style&index=0&id=9c367f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c367f42",
  null
  
)

export default component.exports